/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Style imports */
import "./styles.css";

/* Library imports */
import React, {Component} from "react";

/* Component imports */
import ContentLg from "../../../../ContentLg";
import ConstantsLg from "../../../../ConstantsLg";
import TextboxOutline from "../../../core/TextBoxOutline/TextBoxOutline";

/*** End Imports ***/

class SuccessScreen extends Component {
    constructor (props) {
        super(props);
    }

    onTxtBxEmailEditClick = () => {
        this.props.onEmailEditClick();
    };

    render () {
        const {header, message, email} = this.props;

        return (
            <div className={"lg_mdl-rec-success"}>
                <div className={"lg_mdl-rec-succ-banner"}>
                    <img src={ConstantsLg.URL.GREEN_TICK} />
                </div>
                <p className={"lg_mdl-rec-succ-hdr"}>
                    {header}
                </p>
                <p className={"lg_mdl-rec-succ-msg"}>
                    {message}
                </p>

                <div className="rec-lg-tbemail-wrpr" style= {{padding: '0 20px 20px 20px', position: 'relative'}}>
                        <TextboxOutline 
                            ref = { e => this.TxtBxEmailRef = e }
                            textBoxValue = {email}
                            pattern = {ConstantsLg.REGEX.EMAIL}
                            placeholder = {ContentLg.REC_EMAIL_PH}
                            // isRequired = {true}
                            onEnterClick = {this.onTxtBxEmailEnter}
                            maxLength = {50}
                            onChange = {this.onTxtBxEmailChange}
                            isDisabled = {true}
                        />
                        <img
                            className="btn-edit"
                            style = {{
                                top: '38px',
                                right: '30px',
                                position: 'absolute',
                                cursor: 'pointer'
                            }}
                            onClick={this.onTxtBxEmailEditClick}
                            src = {ConstantsLg.ICONS.EDIT_ICON_BLUE}
                        />
                </div>
            </div>
        );
    }
}

export default SuccessScreen;



// WEBPACK FOOTER //
// ./src/components/ProfessionalLoginEmailDesktop/components/SuccessScreen/SuccessScreen.js